import React from 'react';
import apiRequest from '@zr/utilities/api';
import logEvent from '@zr/common/js/log_event';
import alertBubble from '@zr/common/js/alertBubble';
import { Button } from '@zr/zds/src/components/Button';

export type SaveJobButtonProps = {
  /**
   * Job SaveJobURL
   */
  saveJobUrl: string;

  /**
   * Placement ID of the page
   */
  placementId: string;

  /**
   * Impression SuperSet ID of the page
   */
  impressionSuperSetId: string;

  /**
   * Whether the job is already saved or not.
   * Control of state is taken over by this component after initial page load/render.
   *
   * @defaultValue false
   */
  isJobSaved: boolean;
};

export const SaveJobButton = ({
  saveJobUrl,
  placementId,
  impressionSuperSetId,
  isJobSaved = false,
}: SaveJobButtonProps): JSX.Element => {
  const [jobSaved, setJobSaved] = React.useState(isJobSaved);
  const [isSaving, setIsSaving] = React.useState(false);

  const handleSave = async () => {
    setIsSaving(true);

    logEvent('button_click', { field: 'save_job' });

    const url = `${saveJobUrl}&placement_id=${placementId}&impression_superset_id=${impressionSuperSetId}&archive=${
      jobSaved ? 1 : 0 // TODO is this correct? what is `archive` for?
    }`;

    try {
      const resp = await apiRequest(url, { method: 'POST' }, '', true);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const data: { html: unknown } = await resp.json();

      // TODO save job modal
      if (data.html) {
        // renderJobSaveModal(data.html);
        alertBubble('Save Job modal not yet implemented');
      } else {
        setJobSaved(true);
      }
    } catch {
      alertBubble('There was an error saving this job.');
    }

    setIsSaving(false);
  };

  return (
    <Button
      variant="secondary"
      icon={jobSaved ? 'saveBookmarkFilled' : 'saveBookmark'}
      title={jobSaved ? 'Remove saved job' : 'Save job for later'}
      disabled={isSaving}
      onClick={handleSave}
    />
  );
};
